import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export async function setGroupPayloadUsingIds(tree, group, key, payload, { expectedTreeVersion, forceOverwrite } = {}) {
    // GraphQL Int variables reject string values; the server's JSONObject
    // scalar can stringify numbers during round-trips, so coerce here.
    const version = expectedTreeVersion != null && expectedTreeVersion !== "" ? Number(expectedTreeVersion) : undefined
    return mutate(
        gql`
            mutation setPayloadData(
                $tree: String!
                $group: String!
                $key: String!
                $payload: JSONObject!
                $expectedTreeVersion: Int
                $forceOverwrite: Boolean
            ) {
                setGroupPayload(
                    payload: $payload
                    tree: $tree
                    group: $group
                    key: $key
                    expectedTreeVersion: $expectedTreeVersion
                    forceOverwrite: $forceOverwrite
                )
            }
        `,
        {
            tree,
            group,
            payload,
            key,
            expectedTreeVersion: Number.isInteger(version) && version >= 0 ? version : undefined,
            forceOverwrite,
        },
        { returns: "setGroupPayload" }
    )
}
